import Shape from "../../entities/Shape";
import { ENDLESS_FIXED } from "@/constants";
export var generatePage = function (payload) {
    var material = payload.material, selWizard = payload.selWizard, id = payload.id;
    var name = material.name, endless = material.endless, box = material.box, holes = material.holes, solid = material.solid, decorations = material.decorations, layouts = material.layouts;
    var pageId = (id === null || id === void 0 ? void 0 : id.length) ? id : "P".concat(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
    var solidShapes = (selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' ? [] : solid.map(mapShapeInstance(pageId));
    var holeShapes = (selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' ? [] : holes.map(mapShapeInstance(pageId));
    var decorationsShapes = (selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' ? [] : decorations.map(mapShapeInstance(pageId));
    var layoutGroups = {};
    var nearestPageShield = { id: null, dist: Infinity };
    layouts.forEach(function (layout, layoutIndex) {
        var groups = layout.groups, shields_dictionary = layout.shields_dictionary;
        var layoutId = "".concat(pageId, "L").concat(layoutIndex);
        var shieldGroups = {};
        groups.forEach(function (gr, groupIndex) {
            var _a, _b, _c, _d, _e, _f;
            var group_color = gr.group_color, shields = gr.shields, id = gr.id, textStyle = gr.text_style, _g = gr.active_color_mode, active_color_mode = _g === void 0 ? '' : _g, _h = gr.inactive_color_mode, inactive_color_mode = _h === void 0 ? '' : _h;
            var groupId = "".concat(layoutId, "G").concat(groupIndex);
            var group = {};
            if ((selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' && (selWizard === null || selWizard === void 0 ? void 0 : selWizard.data)) {
                var flagMidLength = Math.ceil(selWizard.data.flagMidLength);
                var flagLength = ((_a = selWizard.data) === null || _a === void 0 ? void 0 : _a.pages) && ((_b = selWizard.data) === null || _b === void 0 ? void 0 : _b.pages[pageId]) ?
                    Math.ceil(((_d = (_c = selWizard.data) === null || _c === void 0 ? void 0 : _c.pages[pageId]) === null || _d === void 0 ? void 0 : _d.flagLength) * 10) / 10
                    :
                        Math.ceil(selWizard.data.flagLength * 10) / 10;
                if ((shields === null || shields === void 0 ? void 0 : shields.length) === 1) {
                    shields.push(JSON.parse(JSON.stringify(shields[0])));
                    shields[1].shield_id = 'g0s1T1';
                    shields[1].shield_definition_id = 'g0s1T1';
                }
                if ((shields_dictionary === null || shields_dictionary === void 0 ? void 0 : shields_dictionary.length) === 1) {
                    shields_dictionary.push(JSON.parse(JSON.stringify(shields_dictionary[0])));
                    shields_dictionary[1].id = shields[1].shield_definition_id;
                }
                shields[0].primitiveProps.w = flagLength;
                shields[1].primitiveProps.w = flagLength;
                shields[0].position.x = 0;
                shields[1].position.x = flagLength + flagMidLength;
                shields_dictionary[0].solid.box.r = flagLength;
                shields_dictionary[1].solid.box.r = flagLength;
                solidShapes.push({
                    id: pageId + "-solid-rect-" + Number(new Date()),
                    primitiveType: "rect",
                    primitiveProps: {
                        x: flagLength,
                        y: shields[0].position.y,
                        w: flagMidLength,
                        h: shields[0].primitiveProps.h,
                        roundedCornerRadius: 0
                    },
                    logicalType: "solid",
                    fillColor: "#BBBBBB",
                    strokeColor: "#BBBBBB",
                    shield_definition_id: null,
                    shield_id: null
                });
                if ((_e = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _e === void 0 ? void 0 : _e.withMiddleLine) {
                    var strokeWidth = selWizard.data.lineThickness;
                    var shortDash = shields[0].primitiveProps.h / 19;
                    var longDash = shortDash * 3;
                    var strokeDasharray = ((_f = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _f === void 0 ? void 0 : _f.lineType) === 'dashed' ? '' + longDash + ' ' + shortDash : '6 0';
                    decorationsShapes.push({
                        id: pageId + "-solid-mid-line-" + Number(new Date()),
                        primitiveType: "line",
                        primitiveProps: {
                            start_point: {
                                x: flagLength + flagMidLength / 2,
                                y: shields[0].position.y,
                            },
                            end_point: {
                                x: flagLength + flagMidLength / 2,
                                y: shields[0].position.y + shields[0].primitiveProps.h,
                            },
                            style: {
                                strokeWidth: strokeWidth,
                                stroke: '#000000',
                                strokeDasharray: strokeDasharray
                            }
                        },
                        logicalType: "solid",
                        fillColor: "#ffffff",
                        strokeColor: "#000000",
                        shield_definition_id: null,
                        shield_id: null,
                        printable: true
                    });
                }
                box.r = box.l + flagLength * 2 + flagMidLength;
            }
            shields.forEach(function (sh, shieldIndex) {
                var primitiveType = sh.primitiveType, logicalType = sh.logicalType, primitiveProps = sh.primitiveProps, position = sh.position, shield_definition_id = sh.shield_definition_id, shield_id = sh.shield_id;
                var shieldId = "".concat(groupId, "S").concat(shieldIndex);
                var shape = new Shape({
                    id: shieldId,
                    primitiveType: primitiveType,
                    logicalType: logicalType,
                    primitiveProps: primitiveProps,
                    fillColor: group_color,
                    strokeColor: '#000000',
                    shield_definition_id: shield_definition_id,
                    shield_id: shield_id,
                    active_color_mode: active_color_mode,
                    inactive_color_mode: inactive_color_mode,
                });
                shape.move({ x: position.x, y: position.y });
                group[shieldId] = Shape.toInitShieldState(shape);
                // find shield nearest to coord 0,0
                var dist = Math.hypot(position.x, position.y);
                if (nearestPageShield.dist > dist) {
                    nearestPageShield.dist = dist;
                    nearestPageShield.id = shieldId;
                }
            });
            shieldGroups[groupId] = {
                shields: group,
                uid: groupId,
                group_color: group_color,
                id: id,
                textStyle: textStyle
            };
        });
        layoutGroups[layoutId] = {
            groups: shieldGroups,
            uid: layoutId,
            shields_dictionary: shields_dictionary
        };
    });
    var newPage = {
        name: name,
        transforms: { angle: 0, mirror_x: false, mirror_y: false },
        box: box,
        endless: endless,
        nearestPageShieldId: nearestPageShield.id,
        layouts: layoutGroups,
        sections: {},
        decorations: decorationsShapes,
        holes: holeShapes,
        solid: solidShapes,
        uid: pageId,
        resizeType: ENDLESS_FIXED
    };
    return newPage;
};
var mapShapeInstance = function (pageId) { return function (shape, index) {
    var logicalType = shape.logicalType, primitiveType = shape.primitiveType, primitiveProps = shape.primitiveProps, printable = shape.printable;
    return (new Shape({
        id: "".concat(pageId, "-").concat(logicalType, "-").concat(new Date().getTime() + index),
        primitiveType: primitiveType,
        logicalType: logicalType,
        primitiveProps: primitiveProps,
        fillColor: '#ffffff',
        strokeColor: '#000000',
        shield_definition_id: null,
        shield_id: null,
        printable: printable,
        active_color_mode: '',
        inactive_color_mode: '',
    })).toDict();
}; };
